    import {
    commonReducer,
    initialCommonState,
    type commonState,
    type commonAction,
} from "@/hooks/reducers/common.reducer";
import type { parsedApiError } from "@/types/api/errors.api";
import type { paginatedResponse } from "@/types/api/paginated.api";
import type { user } from "@/types/api/user.api";
import type { simulation } from "../dashboard/types.api";

export interface assignmentsState extends commonState {
    student: user | null;
    assigned: paginatedResponse<simulation>;
    available: paginatedResponse<simulation>;
    activeTab: "assigned" | "available";
    exportingId: number | string | null;
    uploadingSimId: number | string | null;
    actionError: parsedApiError | null;
}

export type assignmentsAction =
    | commonAction
    | { type: "SET_STUDENT"; payload: user }
    | { type: "SET_ASSIGNED"; payload: paginatedResponse<simulation> }
    | { type: "SET_AVAILABLE"; payload: paginatedResponse<simulation> }
    | { type: "SET_ACTIVE_TAB"; payload: "assigned" | "available" }
    | { type: "EXPORT_START"; payload: number | string }
    | { type: "EXPORT_SUCCESS" }
    | { type: "EXPORT_FAILURE"; payload: parsedApiError }
    | { type: "CLEAR_ACTION_ERROR" }
    | { type: "UPLOAD_START"; payload: number | string }
    | { type: "UPLOAD_SUCCESS" }
    | { type: "UPLOAD_FAILURE"; payload: parsedApiError };

export const createInitialState = (): assignmentsState => ({
    ...initialCommonState,
    isLoading: true,
    student: null,
    assigned: { results: [], count: 0, next: null, previous: null },
    available: { results: [], count: 0, next: null, previous: null },
    activeTab: "assigned",
    exportingId: null,
    uploadingSimId: null,
    actionError: null,
});

export const assignmentsReducer = (
    state: assignmentsState,
    action: assignmentsAction,
): assignmentsState => {
    const commonState = commonReducer(state, action as commonAction);
    if (commonState !== state) return { ...state, ...commonState };

    switch (action.type) {
        case "SET_STUDENT":
            return { ...state, student: action.payload };
        case "SET_ASSIGNED":
            return { ...state, assigned: action.payload, isLoading: false };
        case "SET_AVAILABLE":
            return { ...state, available: action.payload, isLoading: false };
        case "SET_ACTIVE_TAB":
            return { ...state, activeTab: action.payload };
        case "EXPORT_START":
            return { ...state, exportingId: action.payload, actionError: null };
        case "EXPORT_SUCCESS":
            return { ...state, exportingId: null };
        case "EXPORT_FAILURE":
            return { ...state, exportingId: null, actionError: action.payload };
        case "CLEAR_ACTION_ERROR":
            return { ...state, actionError: null };
        case "UPLOAD_START":
            return { ...state, uploadingSimId: action.payload, actionError: null };
        case "UPLOAD_SUCCESS":
            return { ...state, uploadingSimId: null };
        case "UPLOAD_FAILURE":
            return { ...state, uploadingSimId: null, actionError: action.payload };
        default:
            return state;
    }
};
